// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__Ir+va","content":"Switch_content__l5OSr","on":"Switch_on__ovEYI","on-container":"Switch_on-container__pb1iH"};